import { SCOPE_TYPES } from 'constants/scopes';
import fp from 'lodash/fp';
import objMap from './objMap';

const scopeTypesWithLevel = [
  'VIEW_PROJECT_PROPOSAL',
  'VIEW_HISTORY_LOG_BY_PMS',
  'SUBMIT_REPORT',
  'SUBMIT_REPORT_WITH_CUSTOM_DATE',
  'VIEW_BUDGET',
  'VIEW_EXTENSION',
  'VIEW_PROPOSAL_REVISION',
  'VIEW_REPORT_SUBMISSION',
  'VIEW_TEAM',
  'VIEW_TERMINATION',
  'VIEW_VIREMENT',
  'VIEW_WITHDRAWAL',
  'VOID_EXTENSION',
  'VOID_PROPOSAL_REVISION',
  'VOID_VIREMENT',
  'VOID_WITHDRAWAL',
  'WRITE_BUDGET',
  'WRITE_EXTENSION',
  'WRITE_EXTENSION_WITH_CUSTOM_DATE',
  'WRITE_PROPOSAL_REVISION',
  'WRITE_PROPOSAL_REVISION_WITH_CUSTOM_DATE',
  'WRITE_SCHEDULED_REPORT_SUBMISSION',
  'WRITE_TEAM',
  'WRITE_TERMINATION',
  'WRITE_TERMINATION_WITH_CUSTOM_DATE',
  'WRITE_VIREMENT',
  'WRITE_VIREMENT_WITH_CUSTOM_DATE',
  'WRITE_WITHDRAWAL',
  'WRITE_WITHDRAWAL_WITH_CUSTOM_DATE',
  SCOPE_TYPES.VIEW_PROJECT_APPLICATION,
];
const scopeTypesWithNoLevel = [
  'WRITE_PROJECT',
  'WRITE_ROLE',
  'WRITE_USER',
  'WRITE_FACULTY',
  'WRITE_PASS_ROLE',
  'WRITE_ANY_PASS_ROLE',
  'WRITE_DEPARTMENT',
  'WRITE_PROJECT_CATEGORY',
  'WRITE_REPORTING_PERIOD',
  'WRITE_BUDGET_CATEGORY',
  'WRITE_APPROVAL_ROUTE_TEMPLATE',
  'ASSIGN_APPROVER',
  'WRITE_EMAIL_TEMPLATE',
  'WRITE_ANNUAL_REPORT',
  'WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE',
  'VIEW_ANNUAL_REPORT',
  'VIEW_ALL_ANNUAL_REPORT',
  SCOPE_TYPES.VIEW_ANNUAL_REPORT_PROJECT,
  SCOPE_TYPES.VIEW_OTHER_REPORTS,
  SCOPE_TYPES.WRITE_PROJECT_APPLICATION,
  SCOPE_TYPES.WRITE_PROJECT_APPLICATION_SETTING,
  SCOPE_TYPES.ASSIGN_PROJECT_APPLICATION_ENDORSER,
];

export const scopesWithLevel = fp.pipe(
  fp.pick(scopeTypesWithLevel),
  fp.pickBy((level) => level !== 'NONE'),
  objMap((type, level) => ({ type, level }))
);

export const scopesWithNoLevel = fp.pipe(
  fp.pick(scopeTypesWithNoLevel),
  fp.pickBy(Boolean),
  objMap((type) => ({ type }))
);

export const viewProject = fp.pipe(
  fp.pick('VIEW_PROJECT'),
  fp.mapKeys(() => 'type')
);

export const getScopesFromInput = (scopes) => {
  return [
    viewProject(scopes),
    ...scopesWithNoLevel(scopes),
    ...scopesWithLevel(scopes),
  ];
};

export const getScopesForInitialValues = (scopes) => {
  // get scope of view project for input
  const getViewProject = (scopes) => {
    if (fp.some(({ type }) => type === 'VIEW_ALL_PROJECT')(scopes)) {
      return { VIEW_PROJECT: 'VIEW_ALL_PROJECT' };
    }
    return { VIEW_PROJECT: 'VIEW_ACTIVE_PROJECT' };
  };

  // get scopes with level for input
  const transfromScopesWithLevel = fp.pipe(
    fp.filter(({ type }) => fp.indexOf(type)(scopeTypesWithLevel) > -1),
    fp.transform((result, { type, level }) => {
      result[type] = level;
    }, {})
  );
  const fillInNone = (transformedScopes) =>
    fp.transform(
      (result, scopeType) =>
        (result[scopeType] = transformedScopes[scopeType] || 'NONE'),
      {}
    );

  // scopes without level for input
  const transfromScopesWithoutLevel = fp.pipe(
    fp.filter(({ type }) => fp.indexOf(type)(scopeTypesWithNoLevel) > -1),
    fp.transform((result, { type }) => {
      result[type] = true;
    }, {})
  );
  const transformedScopesWithLevel = transfromScopesWithLevel(scopes);

  return {
    ...getViewProject(scopes),
    ...fillInNone(transformedScopesWithLevel)(scopeTypesWithLevel),
    ...transfromScopesWithoutLevel(scopes),
  };
};
